import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { RaffleCreateComponent } from './create/show.component'
import { RaffleGeneralTabComponent } from './general-tab/show.component'
import { RaffleIndexComponent } from './index/index.component'
import { RaffleShowComponent } from './show/show.component'
import { RaffleLinkedSubscriptionsTabComponent } from './linked-subscriptions-tab/show.component'
import { UserAccessRightsGuard } from '../role/user-role/user-access-rights.guard'
import { RaffleResultsTabComponent } from './results-tab/show.component'
import { AccessRights } from '../role/user-role/user-role'

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.Raffle_read] },
    component: RaffleIndexComponent
  },
  {
    path: 'create',
    component: RaffleCreateComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.Raffle_write] }
  },
  {
    path: ':raffleId',
    component: RaffleShowComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.Raffle_read] },
    children: [
      { path: '', component: RaffleGeneralTabComponent, pathMatch: 'full' },
      {
        path: 'linked-subscriptions',
        component: RaffleLinkedSubscriptionsTabComponent
      },
      {
        path: 'results',
        component: RaffleResultsTabComponent
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RaffleRoutingModule {}
